// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1MPG1","right":"Footer_right__3p7w7","buttons":"Footer_buttons__1caxA"};